import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Cookie () {
	const { t } = useTranslation('survey');

	setTimeout(() => {
		const savedPrefs = localStorage.getItem('consent');
		if (!savedPrefs) {
			const cookieContainerBox = document.querySelector('.cookie-notice-container');
			cookieContainerBox.classList.remove('hide');
		}
	}, 1000);

	function AgreeHandler (e) {
		const cookieContainer = document.querySelector('.cookie-notice-container');
		cookieContainer.classList.add('hide');
		localStorage.setItem('consent', 'accepted');
	}

	return (
		<>
			<div className="cookie-notice-container hide">
				<div className="cn-container">
					<div className="cn-text-container">
						<p>{t('survey.cookie.message')}</p>
					</div>
					<div className="cn-buttons-container">
						<button onClick={(e) => AgreeHandler(e)}>{t('survey.generic.Okay')}</button>
					</div>
				</div>
			</div>
		</>
	);
}
